<template lang="pug">
.col-12.table_item
  .table_item_title.d-flex(@click="expand", :class="{ expand: isExpand }")
    .title.d-flex.align-items-center
      p.i_mb_0 {{ terms.TermsFileData01 }}
    svg-icon.i_ml_1(
      :class="{ expand: isExpand }",
      iconClass="arrow_bottom_g",
      className="arrow_bottom_g"
    )
  .table_item_content.container-fluid(ref="tableitem")
    .row
      .title.i_body 保險商品名稱
      .content.i_body_l {{ terms.TermsFileData01 }}
    .row
      .title.i_body 保險商品之文號及日期
      .content.i_body_l(v-html="terms.TermsFileData02")
    .row
      .title.i_body 契約條款、承保範圍及不保事項
      a.content.i_body(:href="terms.TermsFileData03URL", target="_blank") {{ terms.TermsFileData03 }}
    .row
      .title.i_body 銷售予金融消費者之保險商品預定附加費用率
      .content.i_body_l(v-html="terms.TermsFileData04")
    .row
      .title.i_body 短期費率表 及 保費退費係數表
      a.content.i_body(:href="terms.TermsFileData05URL", target="_blank") {{ terms.TermsFileData05 }}
</template>

<script>
import Velocity from "velocity-animate";

export default {
  name: "TableItem",
  props: {
    terms: Object,
  },
  data() {
    return {
      isExpand: false,
    };
  },
  watch: {
    "$store.state.screenWidth": function () {
      if (this.isExpand) {
        //取得元素完整高度
        var height = this.$refs.tableitem.scrollHeight + 20;

        Velocity(
          this.$refs.tableitem,
          { maxHeight: height, opacity: 1 },
          { duration: 0 }
        );
      }
    },
  },
  mounted() {
    this.onResize();
  },
  methods: {
    onResize() {
      var thiz = this;

      window.onresize = function () {
        // 定義視窗大小變更通知事件
        thiz.$store.state.screenWidth = document.documentElement.clientWidth; //視窗寬度
      };
    },
    expand() {
      this.isExpand = !this.isExpand;

      if (this.isExpand) {
        //取得元素完整高度
        var height = this.$refs.tableitem.scrollHeight + 20;

        Velocity(
          this.$refs.tableitem,
          { maxHeight: height, opacity: 1 },
          { duration: 300 }
        );
      } else {
        Velocity(
          this.$refs.tableitem,
          { maxHeight: 0, opacity: 0 },
          { duration: 300 }
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/customer_service/table_item";
</style>
